import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dept-exam-auth-form',
  templateUrl: './dept-exam-auth-form.component.html',
  styleUrls: ['./dept-exam-auth-form.component.css']
})
export class DeptExamAuthFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Departmental-Exam/dept-exam-authorization/dept-exam-auth-form/dept-exam-auth-form.component.ts